<template>
  <div>
    <el-table :data="cardList" v-loading="loading">
      <el-table-column
        prop="id"
        label="ID"
      />
      <el-table-column
        prop="user_id"
        label="UID"
      />
      <el-table-column
        prop="mobile"
        label="mobile"
      />
      <el-table-column
        prop="wechat_name"
        label="微信号"
      />
      <el-table-column
        prop="remarks"
        label="简介"
      />
      <el-table-column
        prop="id"
        label="操作"
      >
        <template slot-scope="scope">
          <el-button size="mini" @click="handleClean(scope.row.user_id, scope.row.id)">清空</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pager api="vcard_risk_warn_list" model="agent" @data-changed="onDataChanged" />
  </div>
</template>
<script>
  import Pager from "../ui/Pager";
  import request from "../../api/request"
  
  export default {
    name: "AgentVCardRiskWarn",
    components: {
      Pager,
    },
    data() {
      return {
        loading: false,
        cardList: [],
      }
    },
    methods: {
      onDataChanged: function (data) {
        this.cardList = data
      },
      handleClean: async function (user_id, id) {
        await request.agent.post('vcard_risk_warn_clean', {
          user_id: user_id,
          id: id
        })
      }
    },
  }
</script>
